<app-feature-hero
    variant="ims"
    title="Server Monitoring"
    description="Strengthen IT availability & performance with all-in-one server monitoring tools"
    image=""
    imageAlt=""
></app-feature-hero>


<section class="container section-spacing">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">Track ITIM Issues With Server Monitoring Insights</h2>
                <p class="section-paragraph">Infraon ITIM monitors all your IT server components and offers insights on
                    performance issues for better capacity planning. Keep track of disk usage, memory consumption, data
                    loss, and server responsiveness.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-img-right justify-content-center">
                <img src="/assets/img/feature-pages/infraon-ims/server-monitoring/itim-server-main-img.png" width="80%"
                    alt="Server Monitoring">
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>

<section class="container p-b-60 p-t-120">
    <h2 class="section-title text-center p-b-60">Feature Highlights</h2>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/server-monitoring/stack.svg"
                    alt="Stack icon">
            </div>
            <p class="section-title-s">Complete Server Monitoring</p>
            <p class="section-paragraph-s">Use powerful dashboards to assess IT server availability & health in
                real-time. Measure server performance & proactive troubleshoot IT network-related issues.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/server-monitoring/monitor.svg"
                    alt="Monitor screen">
            </div>
            <p class="section-title-s">Monitoring For Windows, Linux, Solaris, AIX, Etc.</p>
            <p class="section-paragraph-s">Check server performance (Windows, Linux, Solaris, AIX, etc.) with
                pre-populated IT device templates. Evaluate under/over-usage, CPU health, or disk utilization</p>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 d-flex align-items-center position-relative bg-black-dots">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                <h2 class="section-title">Other Features</h2>

                <div class="row mx-0 px-0">
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">SNMP & WMI Protocols</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Website/URL Monitoring</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Virtual Server Monitoring</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Guest OS Monitoring</p>
                        </li>
                    </ul>
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Integrated Process & Service Monitoring</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Historical & Future Trend Analysis</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Reports & Dashboards</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box d-flex justify-content-center position-absolute"
                style="right: 0;bottom: 0;">
                <img src="/assets/img/feature-pages/infraon-ims/server-monitoring/woman-1.webp" class="w-60" alt="woman point at features">
            </div>
        </div>
    </div>
</section>


<app-faqs [faqs]="faqs" [theme]="'nms-theme'"></app-faqs>